import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { Utils } from '../functions/utils'
import { ws } from '../functions/ws'
import { IState } from '../models/state'

interface IMatchParams {
	withdrawId: string
}

export const WithdrawDetailsFiatMain = () => {

	const withdrawDetails = useSelector((state: IState) => state.withdrawDetails)

	const { withdrawId } = useParams<IMatchParams>()
	React.useEffect(
		() => {
			ws.send({ type: 'WithdrawDetails.Get', withdrawId } as any)
		},
		[])

	const tags: any = {
		unverified: 'tagPurple',
		pending: 'tagYellow',
		verified: 'tagGreen',
		blocked: 'tagRed',
		admin: 'tagBlack',
		operator: 'tagGrey',
		sent: 'tagGreen',
		cancelled: 'tagRed'
	}

	const approve = () => {
		if (confirm('Are you sure?')) {
			ws.send({ type: 'WithdrawDetails.Approve', withdrawId } as any)
		}
	}

	const cancel = () => {
		if (confirm('Are you sure?')) {
			ws.send({ type: 'WithdrawDetails.Cancel', withdrawId } as any)
		}
	}

	return (
		<div className='ordersMain'>
			<span className='pageTitle'>Withdrawals</span>
			<span className='pageBoxTitle'>Fiat Withdraw Details</span>
			<div>
				<table className='ordersTableMain'>
					<thead>
						<tr className='ordersTableHeaderRow'>
							<td className='ordersTableHeaderRowItem idColumn'>Withdraw ID</td>
							<td className='ordersTableHeaderRowItem dateColumn'>Date</td>
							<td className='ordersTableHeaderRowItem'>Coin</td>
							<td className='ordersTableHeaderRowItem'>Amount</td>
							<td className='ordersTableHeaderRowItem'>Fee</td>
							<td className='ordersTableHeaderRowItem'>Liquid</td>
							<td className='ordersTableHeaderRowItem'>Withdraw Status</td>
						</tr>
					</thead>
					<tbody>
						{withdrawDetails ?
							<tr className='ordersTableBodyRow'>
								<td className='depositsTableBodyRowItem'>{Utils.pad(Utils.base32.encode(withdrawDetails.id || 0), 6)}</td>
								<td className='depositsTableBodyRowItem'>{withdrawDetails.date ? new Date(withdrawDetails.date).toLocaleString('en-GB') : ''}</td>
								<td className='depositsTableBodyRowItem'>{withdrawDetails.coin}</td>
								<td className='depositsTableBodyRowItem grayB'>{withdrawDetails.amount.toFixed(2)}</td>
								<td className='depositsTableBodyRowItem grayB'>{withdrawDetails.fee.toFixed(2)}</td>
								<td className='depositsTableBodyRowItem'>{(withdrawDetails.amount - withdrawDetails.fee).toFixed(2)}</td>
								<td className='depositsTableBodyRowItem'><span className={`profileFormTag ${tags[withdrawDetails.status || '']}`}>{withdrawDetails.status}</span></td>
							</tr>
							: <></>
						}
					</tbody>
				</table>
			</div>
			<br />
			<span className='pageBoxTitle'>Bank Account Details</span>
			<div>
				<table className='ordersTableMain'>
					<thead>
						<tr className='ordersTableHeaderRow'>
							<td className='ordersTableHeaderRowItem'>Bank Number</td>
							<td className='ordersTableHeaderRowItem'>Branch Number</td>
							<td className='ordersTableHeaderRowItem'>Account Number</td>
							<td className='ordersTableHeaderRowItem'>Full Name</td>
							<td className='ordersTableHeaderRowItem'>Document ID Number</td>
							<td className='ordersTableHeaderRowItem'>User Status</td>
							<td className='ordersTableHeaderRowItem'>Actions</td>
						</tr>
					</thead>
					<tbody>
						{withdrawDetails ?
							<tr className='ordersTableBodyRow'>
								<td className='depositsTableBodyRowItem'>{withdrawDetails.bankAccount.bankNumber}</td>
								<td className='depositsTableBodyRowItem'>{withdrawDetails.bankAccount.branchNumber}</td>
								<td className='depositsTableBodyRowItem'>{withdrawDetails.bankAccount.accountNumber}</td>
								<td className='depositsTableBodyRowItem'>{withdrawDetails.fullName}</td>
								<td className='depositsTableBodyRowItem'>{withdrawDetails.docIdNumber}</td>
								<td className='depositsTableBodyRowItem'><span className={`profileFormTag ${tags[withdrawDetails.userStatus || '']}`}>{withdrawDetails.userStatus}</span></td>
								<td className='depositsTableBodyRowItem'><Link className='walletsTableButton' to={`/userDetails/${withdrawDetails.userId}`}>View Details</Link></td>
							</tr>
							: <></>
						}
					</tbody>
				</table>
			</div>
			<br />
			<span className='pageBoxTitle'>Actions</span>
			<div className='pageColumn3Box'>
				<div className='pageColumn3'>
					<div className='kycSubmitButtonRed'>
						<button onClick={cancel} type='submit'>Cancel</button>
					</div>
				</div>
				<div className='pageColumn3'>
					<div className='goBackButtonYellowDiv'>
						<Link className='goBackButtonYellow' to='/withdrawals'>Go Back</Link>
					</div>
				</div>
				<div className='pageColumn3'>
					<div className='kycSubmitButtonGreen'>
						<button onClick={approve} type='submit'>Approve</button>
					</div>
				</div>
			</div>
		</div >
	)
}


// WEBPACK FOOTER //
// ./src/components/withdrawDetailsFiatMain.tsx